import { cn } from '../../../../../utils/cn';

type TransactionAvatarProps = {
  avatarUrl?: string;
  initials: string;
};

export const TransactionAvatar = ({ avatarUrl, initials }: TransactionAvatarProps) => {
  if (avatarUrl) {
    return (
      <div className="h-8 w-8 shrink-0 overflow-hidden rounded-full bg-background">
        <img src={avatarUrl} alt="" className="h-full w-full object-contain" />
      </div>
    );
  }

  return (
    <span
      className={cn(
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-full',
        'border border-border bg-background text-sm font-normal text-foreground',
      )}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
};
